module.exports = __webpack_public_path__ + "img/intermx-1.5fd2ae7a.svg";